import { Breadcrumb } from "antd";
import React from "react"
import { useState } from "react"

import OrderCustomerScreen from "../../../src/components/bnotes_order/OrderCustomerScreen";
import OrderSelectContactScreen from "../../../src/components/bnotes_order/OrderSelectContactScreen";
import OrderSearchScreen from "../bnordersearch/OrderSearchScreen";
import { getCurrenciesDenominationsByCustomer } from "../../networking/NetworkingCurrencies";
import OrderInformationScreen from "../../../src/components/bnotes_order/OrderInformationScreen";
import useLookUpTables from "../maintenance/complaints/useLookUpTables";
import OrderDetailsSummary from "./OrderDetailsSumary";
import { getDefaultAddress } from "../../networking/NetworkingAddresses";
import { useEffect } from "react";
import { getOrderInfo } from "../../networking/NetworkingOrders";
import { DenominationTypes } from "../../constants/DenominationTypes";
import { getDeliveryMethods } from "../../networking/NetworkingBankNotes";
import { getInstrumentsByCustomer } from "../../networking/NetworkingInstruments";
import { getTradingInformationByCustomerID } from "../../networking/NetworkingCustomers";

import { useNavigate } from "react-router-dom";
import AlertBox from "../shared/AlertBox";
import OrderSummary from "../bnotes_order/OrderSummary";

const  OrderDetails = ({buySellSide, responseOrder, backScreenMethod}) => {
    const [step, setStep] = useState(4);
    const companyAddress = localStorage.getItem('BNCompany Address');
    const [buyCurrency, setBuyCurrency] = useState(localStorage.getItem('BNBase Currency'));
    const [buyCurrencyScale, setBuyCurrencyScale] = useState(2);
    const [buyCurrencySymbol, setBuyCurrencySymbol] = useState('');
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [objCustomer, setObjCustomer] = useState({});
    const [objContact, setObjContact] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const baseCCy= localStorage.getItem('BNBase Currency');
    const [reload, setReload] = useState(false);
    const [showCostRate, setShowCostRate] = useState(false);
    const [editCostRate, setEditCostRate] = useState(false);
    const [editCustomerRate, setEditCustomerRate] = useState(false);
    const screenPermisions = JSON.parse(localStorage.getItem('ScreenShowPermissions'));
    const [crossRate, setCrossRate] = useState(0);
    const [instruments, setInstruments] = useState([]);
    const [settlementMethods, setSettlementMethods] = useState([]);
    const [defaultInstrument, setDefaultInstrument] = useState('');
    const [defaultSettlementMethod, setDefaultSettlementMethod] = useState('');    
    const [showExitModal, setShowExitModal] = useState(false);
    const [pendingTx, setPendingTx] = useState(null);  
    const navigate = useNavigate();

    const [objOrder, setObjOrder] = useState({
        BNOrderNo:0,
         CustomerID: -1,
        UserID: '',
        DeliveryDate: new Date().toLocaleDateString('en-US'), 
        DeliveryTime: '', 
        DeliveryCustomerID: 0, 
        DeliveryMethod:'',
        TotalOrder: 0, 
        TotalProfit: 0, 
        OrderFee:0,
        DenominationFee:0,
        DeliveryFee:0,
        DeliveryText:'',
        DeliveryContactName:'',
        OrderRows: [], 
        BuyCurrency:baseCCy,
        CrossRate :0,        
        SettlementIntrument:'',
        SettlementMethod:''
    });
    const [customerAddress, setCustomerAddress] = useState('');


    const [breadcrumb, setBreadbrumb] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [settlementCurrenciesList, setSettlementCurrenciesList] = useState([]);
    const [customerID, setCustomerID] = useState(0);
    const [customerName, setCustomerName] = useState('');
    const [contactID, setContactID] = useState(0);
    const [contactName, setContactName] = useState(0);
    const [deliveryMethods, setDeliveryMethods] = useState([]);
    const [existsRows, setExistsRows] = useState(false); 
    const lookUpTables = useLookUpTables('BN Settlement Delivery Method,BN Payment Delivery Method');
    
    const blankOrder = {
         BNOrderNo:0,
        CustomerID: 0,
        UserID: '',
        DeliveryDate: new Date().toLocaleDateString('en-US'), 
        DeliveryTime: '', 
        DeliveryCustomerID: 0, 
        DeliveryMethod:'',
        TotalOrder: 0, 
        TotalProfit: 0, 
        OrderFee:0,
        DenominationFee:0,
        DeliveryFee:0,
        DeliveryText:'',
        DeliveryContactName:'',
        OrderRows: [], 
        Comments:'',
        BuyCurrency:baseCCy,
        CrossRate:0,
        SettlementIntrument:'',
        SettlementMethod:''
    }

    useEffect(()=>{
        if(screenPermisions){
            if(screenPermisions.ShowOrderCostRate){
                setShowCostRate(screenPermisions.ShowOrderCostRate);
            }
            if(screenPermisions.AllowEditOrderCostRate){
                setEditCostRate(screenPermisions.AllowEditOrderCostRate);
            }
            if(screenPermisions.AllowEditOrderCustomerRate){
                setEditCustomerRate(screenPermisions.AllowEditOrderCustomerRate);
            }
        }
    },[screenPermisions])

    useEffect(() => {
        /*const handleBeforeUnload = (e) => {
            if (!window.isOrderChanged) return;

            e.preventDefault();
            e.returnValue = "";
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };*/
        loadDetails(responseOrder);
    }, []);

    useEffect(() => {
        window.isOrderChanged = ((step === 3 && existsRows) || (step === 4 && (isEdit || (objOrder.BNOrderNo === null || objOrder.BNOrderNo === undefined || objOrder.BNOrderNo === 0))));

        return () => {
            window.isOrderChanged = false;
        };
    }, [step, existsRows, objOrder.BNOrderNo, isEdit]);


    useEffect(() => {
        /*if (buySellSide !== undefined) {
            loadDeliveryMethods();
            setObjOrder(blankOrder);
            setStep(1);
        }*/
      }, [buySellSide]);

    useEffect(()=>{
        const currencies = JSON.parse(localStorage.getItem('Currencies'));
        if(currencies)
        {
            const ccy = currencies.find(c=> c["Currency Id"] === buyCurrency)
            if(ccy)
            {
                setBuyCurrencyScale(ccy.Scale);
                setBuyCurrencySymbol(ccy.Symbol);
            }
        }
    },[buyCurrency])

    const updateBuyCurrencyValue =(value, crossRate)=>{
        setBuyCurrency(value);
        setCrossRate(crossRate);
    }

    const loadCustomerInfo =async(customerID) =>{
        const currenciesResponse = await getCurrenciesDenominationsByCustomer(customerID)
                
        if(currenciesResponse && currenciesResponse.currencies)
        {
            const formattedCurrencies = currenciesResponse.currencies.map(c => ({ ...c, name: c.CurrencyIDName, value: c.CurrencyID }));
            const finalCurrencies = [];
            const finalSettelementCurrencies = [];
            formattedCurrencies.forEach(element => {
            switch (element.Type) {
                case 'Payment':
                finalCurrencies.push(element);
                break;
                case 'Settlement':
                finalSettelementCurrencies.push(element);
                break;
                default:
                break;
            }
            });
            setCurrencies(finalCurrencies);
            setSettlementCurrenciesList(finalSettelementCurrencies);
        }                

        const customerAddressResponse = await getDefaultAddress(customerID);
        if(customerAddressResponse)
        {
            setCustomerAddress(`${customerAddressResponse.AddressValue}${customerAddressResponse.City ? `, ${customerAddressResponse.City}`: '' }${customerAddressResponse.CountryId ? `, ${customerAddressResponse.CountryId}`:''}`);
        }
        else
        {
            setCustomerAddress('');
        }        
        
    }

    const loadDeliveryMethods = async() => {
        const deliveryMethodsResponse = await getDeliveryMethods(buySellSide)

        if(deliveryMethodsResponse) {
            setDeliveryMethods(deliveryMethodsResponse.DeliveryMethod);
        }
    }

    const loadInstruments = async(customerID) =>{
        const instrumentsResponse = await getInstrumentsByCustomer(customerID);
        if(instrumentsResponse){
            let jsonInstruments = instrumentsResponse.instruments;
            if (jsonInstruments !== undefined) {
                var incomingHelper = [];
                let deliveryMethods = {};
                for (var i = 0; i < jsonInstruments.length; i++) {
                    let instrumentElement = {
                        value: jsonInstruments[i].Instrument,
                        name: jsonInstruments[i].Instrument
                    };
                    
                    if (jsonInstruments[i].InstrumentType === 'Incoming') {
                        incomingHelper.push(instrumentElement);
                        let list = [];
                        if(jsonInstruments[i].DeliveryMethods && jsonInstruments[i].DeliveryMethods !== ''){
                            var methodsList = jsonInstruments[i].DeliveryMethods.split('§');
                            for(var j=0; j<methodsList.length; j++){
                                var item = {value:methodsList[j], name:methodsList[j]};
                                list.push(item);
                            }
                        }
                        deliveryMethods[jsonInstruments[i].Instrument] = list;
                    }
                }
                setInstruments(incomingHelper);
                setSettlementMethods(deliveryMethods);
            }
        }
    }

    const loadTradingInfo = async(customerID) =>{
        const response =   await getTradingInformationByCustomerID(customerID)
        if (response != null) 
        {
            if(response.DefaultSettlementInstrument !== undefined && response.DefaultSettlementInstrument !== '')
            {
                setDefaultInstrument(response.DefaultSettlementInstrument);
            }
    
            if(response.DefaultDeliveryMethod !== undefined && response.DefaultDeliveryMethod !== '')
            {
                setDefaultSettlementMethod(response.DefaultDeliveryMethod);
            }
        }
    }

    const handleCustomerSelection = async(obj, nextStep) => {
            
            //Show status warning
            if (obj.Status !== 'Regular' && obj.Status !== 'Monitored') {//(obj.Status !== 'Authorized to deal') {
                nextStep = 1;
                setAlertMessage('Customer is in ' + obj.Status + ' status. Orders cannot be created or edited under this customer.');
                setAlertTitle('Warning');
                setShowAlert(true);
            }
            else
            {
                setObjCustomer(obj);
                setCustomerID(obj['Customer ID']);
                setCustomerName(obj['Customer Name']);
                
                loadCustomerInfo(obj["Customer ID"]);

                loadInstruments(obj["Customer ID"]);

                if(defaultInstrument === ''){
                    setDefaultInstrument(obj['DefaultSettlementInstrument$']);
                }

                if(defaultSettlementMethod === ''){
                    setDefaultSettlementMethod(obj['DefaultDeliveryMethod$']);
                }

                if (nextStep === 2) {                
                    setStep(nextStep);
                    setObjOrder({});
                }
        }
    }

    const handleContactSelection = (obj) => {
        setStep(3);
        setObjContact(obj);
        setContactID(obj['Contact ID']);
        setContactName(obj['Name']);
        setObjOrder({ BuyCurrency: baseCCy});
    }

    const contacts_length = (n) =>{
        if(n===0){
            setStep(1);
            setAlertTitle('Message');
            setAlertMessage('There are no active customer contacts for this customer.');
        }
    }


    const getTab = () =>{
        if (step === 1 || step === 5) {
            return (
                <ul className="uk-tab">
                    <li key="step-1" className={step !== 5? 'uk-active':''}><a onClick={() => setStep(1)}>Search Customer</a></li>
                    <li key="step-5" className={step === 5? 'uk-active':''}><a onClick={() => setStep(5)}>Order Search</a></li>
                </ul>
            );
        }
        else
            return <></>
    }

    const getBreadcrumb = () =>{
        let breadcrumb = [];
        /* switch (step) {
                    case 1:
                    default:
                        breadcrumb.push(<Breadcrumb.Item key="bd-order" className="breadcrumb-item-bold" onClick={() => setStep(1)}>{`${buySellSide} Order`}</Breadcrumb.Item>)   
                        break;
                    case 2:
                        breadcrumb.push(
                                        <Breadcrumb.Item key="bd-order" className="breadcrumb-item" onClick={() => setStep(1)}>{`${buySellSide} Order`}</Breadcrumb.Item>
                                    );
                        breadcrumb.push(
                                        <Breadcrumb.Item key="bd-order-cust" className="breadcrumb-item-bold" onClick={() => setStep(2)}>{objCustomer["Customer Name"]} - Select Contact</Breadcrumb.Item>
                                    );
                        break;
                    case 5:
                        breadcrumb.push(<Breadcrumb.Item key="bd-order" className="breadcrumb-item-bold" onClick={() => setStep(5)}>Order Search</Breadcrumb.Item>)  
                        break;
                    }*/
        breadcrumb.push(<Breadcrumb.Item key="bd-order" className="breadcrumb-item-bold">{`${buySellSide} Order`}</Breadcrumb.Item>)  
        return breadcrumb;
    }

    const backScreen = (obj)=>{
      backScreenMethod();
    }

    const backToSearchScreen = ()=>{
      setStep(5);
    }

    const cleanOrder = () =>{
        setObjOrder(blankOrder);
      }

    const cancelOrder = (obj)=>{
      cleanOrder();
      setStep(1);
    }

    const updateOrderDenominationFee = (objOrder) =>{
        
        let fee = 0;
            objOrder.OrderRows.forEach(row =>{
                let rowFee = 0;

                row.Denominations.forEach( d=>
                    rowFee += d.DenominationFee??0
                );

                row.Fee = rowFee;
                fee += rowFee;
            });            
        
      objOrder.DenominationFee = fee;
        setObjOrder(objOrder);

    }

    const updateOrderRowRate = (objOrder) =>{

        let buyAmountTotal = 0;
            objOrder.OrderRows.forEach(row =>{
                buyAmountTotal += row.BuyAmount;
            });            
        
      objOrder.TotalOrder = buyAmountTotal;
      setObjOrder(objOrder);
      setReload(!reload);      
    }

    const updateOrderRowCostRate = (objOrder) =>{

        let profit = 0;
            objOrder.OrderRows.forEach(row =>{
                profit += row.Profit;
            });            
        
      objOrder.TotalProfit = profit;
      setObjOrder(objOrder);
      setReload(!reload);
    }

    const updateOrderFees = (objOrder, orderFee, deliveryFee) =>{
        
      objOrder.OrderFee = orderFee;
      objOrder.DeliveryFee = deliveryFee;
        setObjOrder(objOrder);

    }

    const loadDetails = async(responseOrder) =>{
        if(responseOrder && responseOrder.BNOrderNo > 0)
        {
            if(responseOrder.CustomerID > 0)
            {
                loadCustomerInfo(responseOrder.CustomerID);
                loadDeliveryMethods();
                loadInstruments(responseOrder.CustomerID);
                setCustomerID(responseOrder.CustomerID);
                setCustomerName(responseOrder.Name);
                setContactID(responseOrder.ContactID);
                setContactName(responseOrder.ContactName);
                responseOrder.DeliveryTime = responseOrder.DeliveryTimeFormat;
                responseOrder.validations = {
                    DeliveryCustomerID: true,
                    DeliveryDate: true,
                    DeliveryTime: true,
                    DeliveryMethod: true
                }

                responseOrder.OrderRows.forEach((row,index) =>{
                    row.key = index;
                    row.DenominationType = DenominationTypes.notes;
                    row.MixedNotes = !(row.Denominations && row.Denominations.length > 0)
                    row.Denominations = (row.Denominations && row.Denominations.length > 0)? row.Denominations: []
      
                    row.validations={
                        CurrencyID: true,
                        Denominations: true,
                        Amount: true,
                        Rate: true,
                        BuyAmount: true
                    }  
                })
                setBuyCurrency(responseOrder.BuyCurrency);

                setObjOrder(responseOrder);

                setIsEdit(false);
                setStep(4);
            }

        }
    }
    
    const handleOrderSelected = async(responseOrder) =>{
        if(responseOrder && responseOrder.BNOrderNo > 0)
        {
            if(responseOrder.CustomerID > 0)
            {
                loadCustomerInfo(responseOrder.CustomerID);
                loadDeliveryMethods();
                loadInstruments(responseOrder.CustomerID);
                setCustomerID(responseOrder.CustomerID);
                setCustomerName(responseOrder.Name);
                setContactID(responseOrder.ContactID);
                setContactName(responseOrder.ContactName);
                responseOrder.DeliveryTime = responseOrder.DeliveryTimeFormat;
                responseOrder.validations = {
                    DeliveryCustomerID: true,
                    DeliveryDate: true,
                    DeliveryTime: true,
                    DeliveryMethod: true
                }

                responseOrder.OrderRows.forEach((row,index) =>{
                    row.key = index;
                    row.DenominationType = DenominationTypes.notes;
                    row.MixedNotes = !(row.Denominations && row.Denominations.length > 0)
                    row.Denominations = (row.Denominations && row.Denominations.length > 0)? row.Denominations: []
      
                    row.validations={
                        CurrencyID: true,
                        Denominations: true,
                        Amount: true,
                        Rate: true,
                        BuyAmount: true
                    }  
                })
                setBuyCurrency(responseOrder.BuyCurrency);

                setObjOrder(responseOrder);

                if(responseOrder.CanEdit)
                {
                setIsEdit(true);
                setStep(3);
                }
                else
                {
                    setIsEdit(false);
                    setStep(4);
                }
            }

        }
    }

    const newOrder = (orderCustomerID, orderContactID, orderCustomerName) =>{
        let newOrder = blankOrder;
        newOrder.CustomerID = orderCustomerID;
       
        if(instruments.length === 0)
        {
            loadInstruments(orderCustomerID); 
            loadCustomerInfo(orderCustomerID);                  
            loadTradingInfo(orderCustomerID);         
        }
        setCustomerID(orderCustomerID);
        setContactID(orderContactID);
        setCustomerName(orderCustomerName);
        setObjOrder(newOrder);
        setStep(3);
    }

    const getOrderUpdated = async(orderNo) =>{
        const responseOrder = await getOrderInfo(orderNo);
        if(responseOrder)
        {
            if(responseOrder && responseOrder.BNOrderNo > 0)
        {
            if(responseOrder.CustomerID > 0)
            {
                responseOrder.DeliveryTime = responseOrder.DeliveryTimeFormat;
                responseOrder.validations = {
                    DeliveryCustomerID: true,
                    DeliveryDate: true,
                    DeliveryTime: true,
                    DeliveryMethod: true
                }

                responseOrder.OrderRows.forEach((row,index) =>{
                    row.key = index;
                    row.DenominationType = DenominationTypes.notes;
                    row.MixedNotes = !(row.Denominations && row.Denominations.length > 0)
                    row.Denominations = (row.Denominations && row.Denominations.length > 0)? row.Denominations: []
      
                    row.validations={
                        CurrencyID: true,
                        Denominations: true,
                        Amount: true,
                        Rate: true,
                        BuyAmount: true
                    }  
                })
                responseOrder.CanEdit = 0;
                setObjOrder(responseOrder);
            }
        }
            setIsEdit(false);
            setStep(4);
        }
    }

    const updateOrderInfo = (obj) =>{
        setObjOrder(obj);
    }
        
    const getStepScreen = () =>{
        let screen = <></>;
         switch (step) {
                    /*case 1:
                    default:
                        screen = (<OrderCustomerScreen id="comp_customer_form"
                            onCustomerSelected={handleCustomerSelection} />);         
                        break;
                    case 2:
                        screen = (<OrderSelectContactScreen id="comp_contact_form"
                                        onContactSelected={handleContactSelection}
                                        contacts_length={contacts_length}
                                        objCustomer={objCustomer} />);
                        break;
                    case 3: 
                        screen = <OrderInformationScreen customerName={customerName} customerID={customerID} objOrder={objOrder} buyScale={buyCurrencyScale} lockedSide={buySellSide} currenciesList={currencies} updateOrder={updateOrderInfo} changeScreen={()=> setStep(4)}
                        deliveryMethodList={deliveryMethods} buyCcy={buyCurrency} crossR={crossRate} updateBuyCurrencyValue={updateBuyCurrencyValue} settlementCurrenciesList={settlementCurrenciesList} editCostRate={editCostRate} showCostRate={showCostRate} editCustomerRate={editCustomerRate}
                        backToSearchScreen={backToSearchScreen} instruments={instruments} settlementMethods={settlementMethods} defaultInstrument={defaultInstrument} defaultSettlementMethod={defaultSettlementMethod} updateExistsRows={(value)=>setExistsRows(value)}/>
                        break;*/
                    case 4:
                        screen= <OrderSummary objOrder={objOrder} buyScale={buyCurrencyScale} lockedSide={buySellSide} cancelOrder={backScreen} companyAddress={companyAddress} customerID={customerID} customerName={customerName}
                                contactID={contactID} contactName={contactName} baseCurrencySymbol={buyCurrencySymbol} customerAddress={customerAddress} updateOrderDenominationFee={updateOrderDenominationFee} updateOrderFees={updateOrderFees} fromSearch={true}
                                newOrder={newOrder} updateOrderRowRate={updateOrderRowRate} updateOrderRowCostRate={updateOrderRowCostRate} reload={reload} editCostRate={editCostRate} showCostRate={showCostRate} editCustomerRate={editCustomerRate} getOrderUpdated={getOrderUpdated}
                                />
                        break;
                    /*case 5:
                        screen = <OrderSearchScreen lockedSide={buySellSide} onOrderSelected={handleOrderSelected}/>;
                        break;*/
                    }
        return screen;
    }

    
    
    return (<>
            <div className="breadcrumb-div">
                <Breadcrumb separator=">">
                    {getBreadcrumb()}
                </Breadcrumb>
            </div>
            {getTab()}
            {getStepScreen()}
            <AlertBox id="warning-alert"
                                open={showAlert}
                                title={alertTitle}
                                message={alertMessage}
                                type="Ok"
                                okClick={() => setShowAlert(false)}
                            />
    </>)
}

export default OrderDetails